module.exports = __webpack_public_path__ + "static/media/metodo_3.8f8c5f04.png";